module.exports = __webpack_public_path__ + "img/tablet.8a5caede.svg";